export default {
  name: {
    id: 'us_telco_comparators_visible_by_verizon_offer_card_name',
    defaultMessage: 'Visible by Verizon',
  },
  promoTitle: {
    id: 'us_telco_comparators_visible_by_verizon_offer_card_promo_title',
    defaultMessage: '$5.00 / month off your plan',
  },
  promoContent: {
    id: 'us_telco_comparators_visible_by_verizon_offer_card_promo_content',
    defaultMessage: 'For 24 months when you buy a Back Market phone.',
  },
  benefitNetwork: {
    id: 'us_telco_comparators_visible_by_verizon_offer_card_benefit_network',
    defaultMessage: 'Verizon 5G & 4G LTE',
  },
  benefitUnlimited: {
    id: 'us_telco_comparators_visible_by_verizon_offer_card_benefit_unlimited',
    defaultMessage: 'Unlimited data, call and text',
  },
  benefitFamily: {
    id: 'us_telco_comparators_visible_by_verizon_offer_card_benefit_family',
    defaultMessage: 'Family supported',
  },
  modalStep1: {
    id: 'us_telco_comparators_visible_by_verizon_offer_card_modal_step_1',
    defaultMessage: 'Buy any unlocked phone on Back Market.',
  },
  modalStep2: {
    id: 'us_telco_comparators_visible_by_verizon_offer_card_modal_step_2',
    defaultMessage: 'Get the promo code in your confirmation email.',
  },
  modalStep3: {
    id: 'us_telco_comparators_visible_by_verizon_offer_card_modal_step_3',
    defaultMessage: 'Use your code at checkout on the Visible site.',
  },
  modalCtaLabel: {
    id: 'us_telco_comparators_visible_by_verizon_offer_card_modal_cta_label',
    defaultMessage: 'Select a phone',
  },
  modalCtaLink: {
    id: 'us_telco_comparators_visible_by_verizon_offer_card_modal_cta_link',
    defaultMessage: '/l/smartphones-unlocked',
  },
}
